module.exports = "https://coursera_assets.s3.amazonaws.com/images/7b2eac8a8dc4112e62c646b6ed366d28.png";